import {Flex, Text} from '@chakra-ui/react'
import {randomElementIndexInArray} from '@utils'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

const ArrangementPhrase = ({
  setDataReply,
  setIsResult,
}: {
  setDataReply: any
  setIsResult: any
}) => {
  const {currentQuestion, isDisableReply} = useSelector(
    (state: any) => state.revise,
  )
  const [textOptions, setTextOption] = useState<any>()
  const [textQuestions, setTextQuestions] = useState<any>([])

  useEffect(() => {
    if (!currentQuestion) {
      return
    }
    const textDemoSplit = currentQuestion.data.question.fill_answer?.split(' ')
    const newTextQuestions = textDemoSplit.map((item: any) => {
      const type = item.includes('_') ? 'empty' : null
      if (item) {
        return {
          text: item,
          type: type,
        }
      }
    })
    const updateNewTextQuestions = newTextQuestions.filter(
      (item: any) => item !== '' && item !== undefined && item !== null,
    )

    setTextQuestions(updateNewTextQuestions)
    const options = currentQuestion.data.question.fill_words?.concat(
      currentQuestion.data.question.extra_words,
    )
    setTextOption(randomElementIndexInArray(options))
  }, [currentQuestion])

  useEffect(() => {
    const arr = textQuestions
      .filter((item: any) => item.type === 'option')
      .map((i: any) => i.text)
    const result =
      JSON.stringify(arr).replace(/\s+/g, '').toLowerCase() ===
      JSON.stringify(currentQuestion.data.question.fill_words)
        .replace(/\s+/g, '')
        .toLowerCase()
    setIsResult(result)
  }, [textQuestions])

  // Xử lý chọn từ cần điền vào chỗ trống đầu tiền
  const handleClickTextOption = (text: any) => {
    if (isDisableReply) {
      return
    }
    const newTextQuestions = [...textQuestions]
    let isPause = false
    textQuestions?.forEach((element: any, index: any) => {
      if (element.type === 'empty' && !isPause) {
        const newItem = {text: text, type: 'option'}
        isPause = true
        newTextQuestions[index] = newItem
        setTextQuestions(newTextQuestions)
        const newTextOptions = textOptions?.filter((item: any) => text !== item)
        setTextOption(newTextOptions)
        if (
          newTextOptions.length ===
            currentQuestion.data.question.extra_words.length ||
          !newTextQuestions?.find((item: any) => item?.type === 'empty')
        ) {
          setDataReply(newTextQuestions)
        }
      }
    })
  }

  // Xử lý bỏ chọn từ đã chọn
  const handleClickTextSelected = (item: any) => {
    if (isDisableReply) {
      return
    }
    const newTextQuestions = [...textQuestions]
    const newTextOption = [...textOptions]
    textQuestions.forEach((element: any, index: any) => {
      if (element.text === item.text && element.type === 'option') {
        const newItem = {text: '____', type: 'empty'}
        newTextQuestions[index] = newItem
        newTextOption.push(item.text)
        setTextQuestions(newTextQuestions)
        setTextOption(newTextOption)
      }
    })
    setDataReply(null)
  }

  return (
    <Flex w={'90%'} ml={'auto'} mb={'16px'} flexDirection={'column'}>
      <Flex
        gap={'4px'}
        alignItems={'center'}
        flexWrap={'wrap'}
        fontSize={'16px'}
        p={'16px'}
        bg={isDisableReply ? '#F5F5F5' : '#E6F7FF'}
        borderRadius={'32px'}
        w={'fit-content'}
        ml={'auto'}>
        {textQuestions?.map((item: any, index: any) => {
          return (
            <Text
              key={index}
              fontFamily={item.type === 'empty' ? 'Lexend' : 'unset'}
              mx={item.type === 'option' ? '4px' : '0px'}
              cursor={item.type === 'option' ? 'pointer' : 'unset'}
              p={item.type === 'option' ? '6px 15px' : 'unset'}
              borderRadius={item.type === 'option' ? '12px' : 'unset'}
              border={item.type === 'option' ? '1px solid #D9D9D9' : 'unset'}
              fontWeight={item.type === 'option' ? 600 : 500}
              color={
                isDisableReply
                  ? 'rgba(0, 0, 0, 0.25)'
                  : item.type === 'option'
                    ? '#595959'
                    : '#0050B3'
              }
              bg={item.type === 'option' ? 'white' : 'unset'}
              onClick={() => handleClickTextSelected(item)}>
              {item.text}
            </Text>
          )
        })}
      </Flex>
      <Flex
        mt={'16px'}
        gap={'16px'}
        justifyContent={'end'}
        flexWrap={'wrap'}
        w={'60%'}
        ml={'auto'}>
        {textOptions?.map((item: any, index: any) => {
          return (
            <Text
              key={index}
              cursor={isDisableReply ? 'unset' : 'pointer'}
              p={'6px 15px'}
              borderRadius={'12px'}
              border={'1px solid #D9D9D9'}
              fontWeight={600}
              color={isDisableReply ? 'rgba(0, 0, 0, 0.25)' : '#595959'}
              bg={isDisableReply ? '#F5F5F5' : 'unset'}
              onClick={() => handleClickTextOption(item)}>
              {item}
            </Text>
          )
        })}
      </Flex>
    </Flex>
  )
}

export default ArrangementPhrase
